<div class="top-menu">
    <button class="icon icon-arrow-back" (click)="close()"></button>
</div>
<div class="card-selection-menu" [class.card-selection-menu-disabled]="!resultChange.selectedCard">
    <div class="suits-selection">
        @for (cardSuit of cardSuits; track cardSuit.id) {
            <div
                class="icon-suit-wrapper interactive"
                [class.suit-active]="cardSuit.id === selectedSuitId"
                (click)="selectedSuitId = cardSuit.id"
            >
                <div class="icon-suit icon-{{ cardSuit.name }}"></div>
            </div>
        }
    </div>
    <div class="cards-selection">
        @for (cardNumber of cardNumbers; track cardNumber) {
            <div class="card-placeholder interactive" (click)="selectCard(selectedSuitId + cardNumber)">
                <app-card [cardValue]="selectedSuitId + cardNumber"></app-card>
            </div>
        }
    </div>
</div>

<div class="buttons-container">
    <button i18n (click)="confirm()" [disabled]="!resultChange.canConfirm" class="button-game button-game-medium button-special">
        Confirm
    </button>
</div>
